<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { motion } from "motion-v";
import MaterialSymbolsSearchOffRounded from '~icons/material-symbols/search-off-rounded'
import SvgSpinnersPulseRings3 from '~icons/svg-spinners/pulse-rings-3'
import BButton from '@/components/common/bButton.vue'

const { t } = useI18n();

const props = defineProps<{
  title: string,
  notFound: string,
  list: any[]
  isLoading: boolean
  total?: number
  isLoadingMore?: boolean
}>()

const emit = defineEmits<{
  'load-more': []
}>()

const canLoadMore = () => {
  return (props.total ?? props.list.length) > props.list.length
}

</script>

<template>
  <div class="flex flex-col gap-2">

    <div class="flex gap-4 flex-wrap items-center">

      <h2 class="text-xs font-semibold">
        {{ title }}

      </h2>
      <SvgSpinnersPulseRings3 class="text-primary-600" v-if="isLoading" />
      <div class="flex gap-2" v-else-if="list.length === 0">
        <MaterialSymbolsSearchOffRounded />
        <p class="text-xs">{{ notFound }}</p>
      </div>
    </div>

    <ul v-if="list.length > 0" id="options" class=" text-sm" role="listbox">
      <motion.div v-for="(item, index) in list" :key="item._id" :initial="{ opacity: 0, y: 5, filter: 'blur(10px)' }"
        :animate="{ opacity: 1, y: 0, filter: 'blur(0px)' }" :transition="{ delay: index * 0.05 }">
        <slot :item="item"></slot>
      </motion.div>
    </ul>

    <div v-if="list.length > 0 && canLoadMore()" class="flex justify-center pt-2">
      <BButton size="small" bg="base" :disabled="isLoadingMore" @click="emit('load-more')">
        <SvgSpinnersPulseRings3 v-if="isLoadingMore" class="text-primary-600" />
        <template v-else>
          {{ t('common.showMore') }}
        </template>
      </BButton>
    </div>
  </div>

</template>
